export default __webpack_public_path__ + "static/media/img-0210-mexico-full-face.0c2adc30.png";